<!-- 配件销售历史 -->
<template>
    <div v-loading="loading">
        <div class="search-ctn" style="min-height: 0; margin-top: 10px">
            <div class="search-ctn-left">
                <div class="flex">
                    <div class="search-name">汽配编码</div>
                    <el-input class="search-item" size="small" v-model="searchData.APCode" placeholder="请输入汽配编码"></el-input>
                    <div class="search-name">汽配名称</div>
                    <el-input class="search-item" size="small" v-model.trim="searchData.GoodName" placeholder="请输入汽配名称"></el-input>
                    <div class="search-name">适用车型</div>
                    <el-input class="search-item" size="small" v-model.trim="searchData.AutoSerise" placeholder="适用车型"></el-input>
                    <div class="search-name">互换码</div>
                    <el-input class="search-item" size="small" v-model.trim="searchData.GoodCode" placeholder="请输入互换码"></el-input>
                </div>
            </div>
        </div>
        <div class="search-ctn" style="min-height: 0">
            <div class="search-ctn-left">
                <div class="flex">
                    <div class="search-name">品牌</div>
                    <div class="search-item goods-categories">
                        <el-select
                            v-model="searchData.BrandName"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            size="small"
                            style="width: 100%"
                            @visible-change="brandVisibleChange($event)"
                        >
                            <el-option :key="item.Text" v-for="item in brandList" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </div>
                    <div class="search-name">汽配分类</div>
                    <div class="search-item goods-categories">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.APCate"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            remote
                            :remote-method="searchGoodsType"
                            v-select-scroll-more="searchGoodsTypeLoad"
                            @visible-change="cateVisibleChange($event)"
                        >
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </div>
                    <div class="search-name">时间区间</div>
                    <el-date-picker
                        v-model="dateTimes"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        @change="handleChange"
                        size="small"
                        class="search-name"
                    ></el-date-picker>
                    <div class="search-name">
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                        <el-button class="search-btn btn-primary" size="small" @click="chooseAPs()">确定 (选中{{ selection.length }}项)</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                border
                style="width: 100%; margin-bottom: 0px"
                @selection-change="onColumnSelect"
                :row-key="getRowKeys"
                @row-dblclick="rowClick"
                ref="g_multipleTable"
            >
                <el-table-column type="selection" width="55" reserve-selection :selectable="selectInit"></el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="CusSourcesName" label="销售来源">
                    <template slot-scope="scope">
                        <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.CusSourcesName }} </i>
                        <i v-else>{{ scope.row.CusSourcesName }} </i>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="70px" v-if="IsBPriceShow" prop="OrgName" label="部门">
                    <template slot-scope="scope">
                        <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.OrgName }} </i>
                        <i v-else>{{ scope.row.OrgName }} </i>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="SName" label="开单员">
                    <template slot-scope="scope">
                        <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.SName }} </i>
                        <i v-else>{{ scope.row.SName }} </i>
                    </template>
                </el-table-column>
                <el-table-column width="170px" prop="OrderCode" label="订单号" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.OrderCode }} </i>
                        <i v-else>{{ scope.row.OrderCode }} </i>
                    </template>
                </el-table-column>
                <el-table-column width="160px" prop="APCode" label="汽配编码" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.APCode }} </i>
                        <i v-else>{{ scope.row.APCode }} </i>
                    </template>
                </el-table-column>
                <el-table-column prop="GoodsName" label="配件名称" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.GoodsName }} </i>
                        <i v-else>{{ scope.row.GoodsName }} </i>
                    </template>
                </el-table-column>
                <el-table-column prop="AutoSerise" label="适用车型" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.AutoSerise }} </i>
                        <i v-else>{{ scope.row.AutoSerise }} </i>
                    </template>
                </el-table-column>
                <el-table-column prop="Brand" width="80px" v-if="IsShowBrand" label="品牌" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.Brand }} </i>
                        <i v-else>{{ scope.row.Brand }} </i>
                    </template>
                </el-table-column>
                <el-table-column prop="Origin" width="80px" v-if="IsBPriceShow" label="产地" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.Origin }} </i>
                        <i v-else>{{ scope.row.Origin }} </i>
                    </template>
                </el-table-column>
                <el-table-column prop="Size" width="70px" v-if="IsBPriceShow" label="规格" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.Size }} </i>
                        <i v-else>{{ scope.row.Size }} </i>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="70px" prop="SalePrice" label="售价"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" v-if="IsBPriceShow" prop="BillingPrice" label="开单价"></el-table-column>
                <el-table-column show-overflow-tooltip width="60px" prop="ReturnCount" label="数量"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="WarehousedCount" label="已出仓数"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="AlReturnCount" label="已退数量"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" label="可退数量">
                    <template slot-scope="scope">
                        <div style="color: red" v-if="scope.row.WarehousedCount - scope.row.AlReturnCount == 0">
                            {{ scope.row.WarehousedCount - scope.row.AlReturnCount }}
                        </div>
                        <div v-else>{{ scope.row.WarehousedCount - scope.row.AlReturnCount }}</div>
                    </template></el-table-column
                >
                <!-- <el-table-column show-overflow-tooltip width="80px" prop="Unit" label="单位"></el-table-column> -->
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <!-- 销售历史 -->
        <el-dialog
            :title="SaleDialogTitle"
            :close-on-click-modal="false"
            :visible.sync="eyeHistoryVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
        >
            <div v-if="eyeHistoryVisible">
                <APHistory
                    ref="APHistory"
                    :showCusColumn="false"
                    :EntpCusId="EntpCusId"
                    :EntpTempGoodsId="hisGoodsId"
                    :EntpCusName="EntpCusName"
                    :NoInit="true"
                    @closeDialog="eyeHistoryVisible = false"
                ></APHistory>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import APHistory from '@/components/common/APHistory';
import returnsOut_NewVue from '../business/goods/returnsOut_New.vue';
import { copyFileSync } from 'fs';
export default {
    name: '',
    props: {
        EntpCusId: {
            type: String
        },
        EntpCusName: {
            type: String
        },
        IsBPriceShow: {
            type: Boolean
        },
        IsShowBrand: {
            type: Boolean
        },
        DataList: {
            type: Array
        }
    },
    components: { APHistory },
    data() {
        return {
            loading: false,
            selLoading: false,
            eyeHistoryVisible: false,
            SaleDialogTitle: '',
            hisGoodsId: '',
            typeList: [],
            brandList: [],
            customerList: [],
            orgName: '',
            searchData: {
                EntpCusId: this.EntpCusId,
                APCode: '',
                GoodCode:'',
                GoodName: '',
                AutoSerise: '',
                BrandName: [],
                APCate: [],
                Page: 1,
                Limit: 10,
                StartDate: '',
                EndDate: ''
            },
            statData: [],
            tableData: [],
            tableDataLength: 0,
            avg: 0,
            month: 0,
            year: 0,
            selection: [],
            dateTimes: [new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 90), new Date()],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            isVerifySource: false, //是否检查销售来源是否一致
            IsVerifyOrg:false,//是否检查相同开单部门商品
            CusSourcesName: '',
            noCheck: false
        };
    },
    mounted() {
        this.searchData.StartDate = this.$util.formatDate(this.dateTimes[0]);
        this.searchData.EndDate = this.dateTimes[1];
        let codes = [
            'ssxsmxxzspsfxzly',
            'xsthspbxtbm'
        ];
        this.$util.getSysConfigs(codes).then(data => {
            if (data) {
                for (let i = 0; i < data.length; i++) {
                    let code = data[i].Code;
                    let result = data[i].Result;
                    switch (code) {
                        case 'ssxsmxxzspsfxzly': //是否检查销售来源是否一致
                            this.isVerifySource = result && data[i].Result;
                            break;
                        case 'xsthspbxtbm'://是否检查相同开单部门商品
                            this.IsVerifyOrg = result;
                    }
                }
            }
        });
        this.$util.getSysConfig('ssxsmxxzspsfxzly').then(data => {
            this.isVerifySource = data && data.Result;
        });
        if (this.EntpCusId) this.searchData.EntpCusId = this.EntpCusId;
        else this.$.$util.warningMsg('客户信息异常，请刷新后重试');
        this.getTableData();
    },
    methods: {
        rowClick(row) {
            this.showSaleStat(row);
        },
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.EntpCusId && !that.searchData.EntpCusId) {
                    if (that.customerList.length == 1) that.searchCustomer();
                } else {
                    if (that.customerList.length == 0) that.searchCustomer();
                }
            }
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brandList.length == 0) that.searchGoodsBrand();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList.length == 0) that.searchGoodsType();
            }
        },
        // 搜索顾客
        searchCustomer(key) {
            this.selLoading = true;
            this.$util
                .searchCustomer(key)
                .then(data => {
                    this.customerList = data;
                    this.selLoading = false;
                })
                .catch(() => {
                    this.selLoading = false;
                });
        },
        searchGoodsBrand() {
            this.selLoading = true;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                    this.selLoading = false;
                })
                .catch(() => {
                    this.selLoading = false;
                });
        },
        searchGoodsType() {
            this.selLoading = true;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList = data;
                    this.selLoading = false;
                })
                .catch(() => {
                    this.selLoading = false;
                });
        },
        resetSearch() {
            this.searchData = {
                EntpCusId: this.EntpCusId,
                APCode: '',
                GoodCode:'',
                GoodName: '',
                AutoSerise: '',
                BrandName: [],
                APCate: [],
                Page: 1,
                Limit: 10,
                StartDate: '',
                EndDate: ''
            };
            this.dateTimes = [];
        },
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        // 更新表格数据
        updateTableData(id) {
            this.resetSearch();
            this.searchData.GoodsId = id;
            this.getTableData();
        },
        getTableData() {
            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpSaleOrder/GetItemsForReturn',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                    if (this.DataList.length > 0) {
                        this.orgName = this.DataList[0].OrgName;
                        this.tableData.forEach(goods => {
                            let idx = this.DataList.findIndex(f => f.SaleOrderRsId == goods.SaleOrderRsId);
                            if (idx > -1) {
                                goods.IsSelected = true;
                            }
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onColumnSelect(val) {
            if (this.noCheck) return;
            let isReturn = false;
            if (val.length > 0 && (this.IsBPriceShow || this.isVerifySource)) {
                let isNotEqual_S = false;
                let isNotEqual_O = false;
                let preValue_S = val[0]['CusSourcesName']; // 默认第一项
                let preValue_O = val[0]['OrgName'];
                for (let i = 0; i < val.length; i++) {
                    const element = val[i];
                    if (!isNotEqual_S&&this.isVerifySource) {
                        isNotEqual_S = preValue_S != element.CusSourcesName;
                    }
                    if (!isNotEqual_O&&this.IsBPriceShow) {
                        isNotEqual_O = preValue_O != element.OrgName;
                    }

                    if (isNotEqual_S || isNotEqual_O) break;

                    if (this.DataList.length > 0) {
                        //检查与已经选择在弹窗的数据
                        let ddList = this.DataList;
                        for (let j = 0; j < ddList.length; j++) {
                            const e = ddList[j];
                            if (!isNotEqual_S&&this.isVerifySource) {
                                isNotEqual_S = element.CusSourcesName != e.CusSourcesName;
                            }
                            if (!isNotEqual_O&&this.isVerifySource) {
                                isNotEqual_O = element.OrgName != e.OrgName;
                            }

                            if (isNotEqual_S || isNotEqual_O) break;
                        }
                    }
                }
                if (isNotEqual_S && this.isVerifySource) {
                    isReturn = true;
                    this.noCheck = true;
                    this.$util.warningMsg('请选择相同销售来源的商品明细');
                } else if (isNotEqual_O && this.IsBPriceShow&&this.IsVerifyOrg) {
                    isReturn = true;
                    this.noCheck = true;
                    this.$util.warningMsg('请选择相同部门的销售明细');
                }
            }

            if (!isReturn) this.selection = val;
            else {
                for (let index = 0; index < val.length; index++) {
                    const element = val[index];
                    let isExist = this.selection.find(e => e.SaleOrderRsId == element.SaleOrderRsId);
                    if (!isExist) {
                        this.$refs.g_multipleTable.toggleRowSelection(element, false);
                    }
                }
                this.noCheck = false;
            }
        },
        //多选配件
        chooseAPs() {
            let items = this.selection;
            this.$emit('closeDialog', items);
        },
        getRowKeys(row) {
            return row.SaleOrderRsId;
        },
        searchGoodsTypeLoad() {
            this.typeForm.Page += 1;
            this.searchGoodsType();
        },
        showSaleStat(row) {
            let that = this;
            if (row) {
                that.SaleDialogTitle = '销售数据：' + row.APCode + ' ' + row.GoodsName + ' ' + row.AutoSerise;
                that.hisGoodsId = row.EntpTempGoodsId;
                if (!that.eyeHistoryVisible) that.eyeHistoryVisible = true;
                that.$nextTick(() => {
                    that.$refs.APHistory.updateTableData(row.EntpTempGoodsId);
                });
            }
        },
        selectInit(row, index) {
            // if (this.orgName) {
            //     if (row.WarehousedCount - row.AlReturnCount == 0 || row.IsSelected || this.orgName != row.OrgName || this.CusSourcesName != row.CusSourcesName)
            //         return false;
            //     else return true;
            // } else {
            //     if (row.WarehousedCount - row.AlReturnCount == 0 || row.IsSelected) return false;
            //     else return true;
            // }
            if (row.WarehousedCount - row.AlReturnCount == 0 || row.IsSelected) return false;
            else return true;
        }
    }
};
</script>
<style lang="less">
#change-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        width: 1000px;
        // height: 500px;
        box-shadow: 0 0 9px 3px #999;
    }
    .add-row-dialog {
        width: 340px;
        height: auto;
        .form-div {
            margin-top: 20px;
        }
        .dialog-footer {
            text-align: right;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>
